<script>
    import Router                   from "svelte-spa-router";
    import Login                    from './pages/Login.svelte'
	import Home                     from './pages/Home.svelte'
	import Chat                     from './pages/Chat.svelte'
	import Quotation                from './pages/Quotation.svelte'
	import Invoices                 from './pages/Invoices.svelte'
	import Error404                 from './pages/Error404.svelte'
    import Session                  from "./class/Session";
    import Fit                      from "./pages/Fit.svelte";
    import Contact                  from "./pages/Contact.svelte";
    import Access                   from "./pages/Access.svelte";
    import Faq                      from "./pages/Faq.svelte";
    import Help                     from "./pages/Help.svelte";
    import I18n                     from "./i18n/I18n.svelte";

    let routes = {
        "/":                        Home,
        "/login":                   Login,
        "/home":                    Home,
        "/fit":                     Fit,
        "/chat":                    Chat,
        "/quotation":               Home,
        "/quotation/:id?":          Quotation,
        "/invoices":                Invoices,
        "/contact":                 Contact,
        "/access":                  Access,
        "/faq":                     Faq,
        "/help":                    Help,
        "*":                        Error404,
    };

    Session.sync();
</script>




{#if Session.in()}
    <Router {routes} />
{:else}
    <Login></Login>
{/if}

<I18n />

